import ReactGAModule from "react-ga4";

/**
 * react-ga4 is published as CommonJS only (`exports.default = instance`).
 * Vite's dependency pre-bundler exposes that as the module object, so the real
 * ReactGA instance can sit one level down at `.default`. Webpack (CRA) unwrapped
 * this automatically; here we normalize it once so callers always get the
 * instance with `initialize`, `set`, `send`, and `event`.
 */
const ReactGA =
  ReactGAModule && typeof ReactGAModule.initialize === "function"
    ? ReactGAModule
    : ReactGAModule.default;

export default ReactGA;
